export const SALARY_INITIAL_FILTER_FIELDS = ['name', 'description', 'status']
